import { hsl } from 'polished';
const greyscaleValues = [18, 46, 70, 73, 87];
const greyscale = greyscaleValues.reduce((previous, current) => ({
    ...previous,
    [`grey${current}`]: grey(current),
}), {});
function grey(value) {
    return hsl(0, 0, value / 100);
}
export { greyscale as default, grey };
